import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserState, UserSuccessDispatchProps } from './types';

const initialState: UserState = {
  data: {
    fullname: '',
    email: '',
    playerId: '',
    loggedIn: false,
    balance: 0,
    sessionId: ''
  }
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginSuccess: (state: UserState, action: PayloadAction<UserSuccessDispatchProps>) => {
      state.data.fullname = action.payload.fullname;
      state.data.email = action.payload.email;
      state.data.playerId = action.payload.playerId;
      state.data.loggedIn = true;
      state.data.sessionId = action.payload.sessionId;
    },
    balanceSuccess: (state: UserState, action: PayloadAction<number>) => {
      state.data.balance = action.payload;
    },
    resetState: (state: UserState) => {
      state.data.fullname = '';
      state.data.email = '';
      state.data.playerId = '';
      state.data.loggedIn = false;
      state.data.balance = 0;
      state.data.sessionId = '';
    }
  }
});

export const { loginSuccess, balanceSuccess, resetState } = userSlice.actions;

export default userSlice.reducer;
